module.exports = __webpack_public_path__ + "assets/contact_support.76e5c960.svg";